module.exports = __webpack_public_path__ + "static/media/maxus.14837a3a.png";